const eventReducer = (state, action) => {
  switch (action.type) {
    case 'EVENT_LOAD':
      return { ...state, eventProgress: true, eventError: null };
    case 'EVENT_SUCCESS':
      return {
        ...state,
        eventProgress: false,
        hasTicketAccess: true,
        eventLoaded: true,
        event: action.event,
        eventError: null,
      };
    case 'EVENT_NO_TICKET':
      return {
        ...state,
        hasTicketAccess: false,
      };
    case 'EVENT_ERROR':
      return {
        ...state,
        eventProgress: false,
        eventLoaded: true,
        eventError: action.error,
      };
    default:
      return state;
  }
};

export default eventReducer;
